export class ControllerPrefsUx
{
    constructor(json: object = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);
        }

        // Handle any custom mappings here or use getters and setters. Object.assign will call
        // property setters.
    }
    ShowLanguage: boolean;
    ShowUnits: boolean;
    ShowBacklightOn: boolean;
    ShowConcurrentSchedules: boolean;
    ShowLcdContrast: boolean;
    ShowSoundOn: boolean;
    ShowStackOverlap: boolean;
    ShowRunTimeFormat: boolean;
    ShowHardwireSensor: boolean;

}
